import React, { useState, useEffect } from "react";
import Axios from "axios";

const LoopExpansionFrame = ({ setCurrentFrame, project }) => {
    const [currentTime, setCurrentTime] = useState("");
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const loopCardNb = project?.panel?.VT5000_CONFIG?.GeneralParameters?.loopCardNb || 0;

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            let formattedTime = now.toLocaleString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).replace(/,/g, ""); // Remove comma between date and time

            formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
            setCurrentTime(formattedTime);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (loopCardNb >= 1 && loopCardNb <= 4) {
            setSelectedCheckbox(loopCardNb);
        }
    }, [loopCardNb]);

    const handleCheckboxChange = (index) => {
        setSelectedCheckbox(index === selectedCheckbox ? null : index);
    };

    const handleSave = () => {
        if (project?.panel?.VT5000_CONFIG?.GeneralParameters) {
            project.panel.VT5000_CONFIG.GeneralParameters.loopCardNb = selectedCheckbox === null ? 0 : selectedCheckbox;

            const userEmail = localStorage.getItem('userEmail');
            Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_generalparameters`, {
                projectId: project.project_id,
                generalparameters: project.panel.VT5000_CONFIG.GeneralParameters
            })
                .then((response) => {
                    if (response.data.success) {
                        setCurrentFrame("additionalCards")
                        console.log("Loop settings updated successfully");
                    } else {
                        console.error("Failed to update loop settings");
                    }
                })
                .catch((error) => {
                    console.error("Error updating loop settings:", error);
                });
        }
    };


    return (
        <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ fontSize: 40, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ textAlign: "left", flex: 1 }}>Loop Expansion</span>
                <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span>
            </div>
            <hr style={{ width: "100%", border: "1px solid black", margin: "5px 0" }} />
            <div style={{ fontSize: "30px", marginBottom: "10px", marginTop: "9%" }}>Loop Expansion Cards</div>
            <div style={{ display: "flex", justifyContent: "center", gap: "1px" }}>
                {[1, 2, 3, 4].map((num) => (
                    <div key={num} style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100px", height: "100px", border: "2px solid black", borderRadius: "5px", cursor: "pointer", background: selectedCheckbox === num ? "#C00D0D" : "#FFF" }}
                        onClick={() => handleCheckboxChange(num)}>
                        <span style={{ fontSize: "40px", fontWeight: "bold", color: selectedCheckbox === num ? "#FFF" : "#000" }}>{num}</span>
                    </div>
                ))}
            </div>
            <div style={{ fontSize: "30px", marginTop: "10px" }}>Each card is equal to 2 Loop</div>
            <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 40% 0 0", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("main")}>Logout</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 1px 0 0", background: "none", borderRadius: "5px" }} onClick={handleSave}>Save</button>
                <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 0px", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("additionalCards")}>Back</button>
            </div>
        </div>
    );
};

export default LoopExpansionFrame;
